var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications-header"},[_c('div',{staticClass:"header-icon"},[_c('img',{attrs:{"src":_vm.notificationsIcon,"alt":"notificaciones"}})]),_vm._v(" "),_c('h2',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.$t('notifications.title')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }